"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagCN = function FlagCN(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-125-80l6.74,20.19,21.28.17a2.87,2.87,0,0,1,1.68,5.17l-17.12,12.64L-106-21.58a2.87,2.87,0,0,1-4.4,3.2l-17.31-12.38L-145-18.38a2.87,2.87,0,0,1-4.4-3.2L-143-41.87l-17.12-12.64a2.87,2.87,0,0,1,1.68-5.17l21.28-.17L-130.43-80A2.86,2.86,0,0,1-125-80Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-47.72-75.06l4.82,6.58,7.8-2.43a1.1,1.1,0,0,1,1.22,1.69l-4.77,6.62,4.72,6.66a1.1,1.1,0,0,1-1.23,1.69l-7.77-2.49-4.88,6.55a1.1,1.1,0,0,1-2-.65l0-8.17-7.74-2.61a1.09,1.09,0,0,1,0-2.08l7.75-2.56.09-8.17a1.1,1.1,0,0,1,2-.63Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-77.11-94.68l8.11.88,3.46-7.4a1.11,1.11,0,0,1,2.08.25l1.67,8,8.09,1a1.1,1.1,0,0,1,.41,2l-7.08,4.06,1.55,8a1.1,1.1,0,0,1-1.82,1l-6-5.49-7.15,4a1.1,1.1,0,0,1-1.53-1.42L-72-87.21l-6-5.58a1.09,1.09,0,0,1,.87-1.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-64.29-15.57-69.11-9l-7.79-2.43a1.1,1.1,0,0,0-1.23,1.69l4.77,6.62-4.72,6.66a1.1,1.1,0,0,0,1.23,1.68l7.78-2.48L-64.2,9.3a1.1,1.1,0,0,0,2-.66l0-8.16,7.73-2.61a1.1,1.1,0,0,0,0-2.09l-7.76-2.55-.09-8.16a1.1,1.1,0,0,0-2-.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-34.89-34l-8.12.88-3.46-7.39a1.1,1.1,0,0,0-2.07.24l-1.67,8-8.1,1a1.1,1.1,0,0,0-.41,2l7.08,4.06-1.54,8a1.09,1.09,0,0,0,1.81,1l6-5.48,7.15,3.94a1.1,1.1,0,0,0,1.53-1.41L-40-26.54l6-5.58A1.1,1.1,0,0,0-34.89-34Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagCN;
exports["default"] = _default;